__turbopack_context__.v({
  "btn": "Button-module-scss-module__H_TBkG__btn",
  "btn_callout": "Button-module-scss-module__H_TBkG__btn_callout",
  "btn_custom_size": "Button-module-scss-module__H_TBkG__btn_custom_size",
  "btn_disabled": "Button-module-scss-module__H_TBkG__btn_disabled",
  "btn_group": "Button-module-scss-module__H_TBkG__btn_group",
  "btn_group_center": "Button-module-scss-module__H_TBkG__btn_group_center",
  "btn_group_left": "Button-module-scss-module__H_TBkG__btn_group_left",
  "btn_group_right": "Button-module-scss-module__H_TBkG__btn_group_right",
  "btn_group_vertical": "Button-module-scss-module__H_TBkG__btn_group_vertical",
  "btn_has_callout": "Button-module-scss-module__H_TBkG__btn_has_callout",
  "btn_icon": "Button-module-scss-module__H_TBkG__btn_icon",
  "btn_icon_filled": "Button-module-scss-module__H_TBkG__btn_icon_filled",
  "btn_large": "Button-module-scss-module__H_TBkG__btn_large",
  "btn_medium": "Button-module-scss-module__H_TBkG__btn_medium",
  "btn_mobile_custom_size": "Button-module-scss-module__H_TBkG__btn_mobile_custom_size",
  "btn_mobile_large": "Button-module-scss-module__H_TBkG__btn_mobile_large",
  "btn_mobile_medium": "Button-module-scss-module__H_TBkG__btn_mobile_medium",
  "btn_mobile_small": "Button-module-scss-module__H_TBkG__btn_mobile_small",
  "btn_mobile_xsmall": "Button-module-scss-module__H_TBkG__btn_mobile_xsmall",
  "btn_outline": "Button-module-scss-module__H_TBkG__btn_outline",
  "btn_small": "Button-module-scss-module__H_TBkG__btn_small",
  "btn_solid": "Button-module-scss-module__H_TBkG__btn_solid",
  "btn_text": "Button-module-scss-module__H_TBkG__btn_text",
  "btn_white": "Button-module-scss-module__H_TBkG__btn_white",
  "btn_xsmall": "Button-module-scss-module__H_TBkG__btn_xsmall",
});
